module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 847 492.2"}},[_c('path',{attrs:{"d":"M11 423.1h823.9v69.1H11zM11 212.1h823.9v69.1H11zM11 .1h823.9v69.1H11z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.svg
// module id = 590
// module chunks = 1